// extracted by mini-css-extract-plugin
export var actionButton = "_x2-2";
export var card = "_x2-0";
export var errorCard = "_x2-1";